
import { useState } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SEOHead from '../../components/SEOHead';

export default function Home() {
  const [showContactModal, setShowContactModal] = useState(false);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "PLOMB'ART",
    "description": "Entreprise de plomberie diplômée ITS à Lyon. Installation de salles de bains, chauffe-eau, dépannage urgent 7j/7.",
    "url": import.meta.env.VITE_SITE_URL,
    "telephone": "+33762551412",
    "email": "contacts@plomb-art.fr",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "30 avenue Maréchal Foch, Bureau 3",
      "addressLocality": "Lyon",
      "postalCode": "69006",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 45.764043,
      "longitude": 4.835659
    },
    "openingHours": "Mo-Su 00:00-23:59",
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": 45.764043,
        "longitude": 4.835659
      },
      "geoRadius": "50000"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services de plomberie",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Installation de salle de bain",
            "description": "Installation complète de salles de bains modernes et fonctionnelles"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Dépannage plomberie",
            "description": "Intervention rapide 7j/7 pour tous vos problèmes de plomberie"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Installation chauffe-eau",
            "description": "Installation et remplacement de chauffe-eau électriques et gaz"
          }
        }
      ]
    },
    "priceRange": "€€",
    "currenciesAccepted": "EUR",
    "paymentAccepted": "Cash, Credit Card, Bank Transfer"
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead structuredData={structuredData} />
      
      <header>
        <h1 className="sr-only">PLOMB'ART - Plombier Lyon</h1>
      </header>
      
      <main>
        <Hero onContactClick={() => setShowContactModal(true)} />
        <Services />
        <WhyChooseUs />
        <Contact />
      </main>
      
      <Footer />
      
      {showContactModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setShowContactModal(false)}>
          <div className="bg-white rounded-lg p-8 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-[#0F5E7E]">Contactez-nous</h3>
              <button onClick={() => setShowContactModal(false)} className="text-gray-500 hover:text-gray-7">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <i className="ri-phone-fill text-[#F5A623] text-xl"></i>
                <a href="tel:0762551412" className="text-gray-700 hover:text-[#0F5E7E]">07 62 55 14 12</a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-mail-fill text-[#F5A623] text-xl"></i>
                <a href="mailto:contacts@plomb-art.fr" className="text-gray-700 hover:text-[#0F5E7E] break-all">contacts@plomb-art.fr</a>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-fill text-[#F5A623] text-xl mt-1"></i>
                <p className="text-gray-700">30 avenue Maréchal Foch<br />Bureau 3<br />69006 LYON</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
